// SEC-101 · Client-side URL scheme allowlist.
//
// The backend already rejects unsafe URL schemes on write (see
// `backend/sanitize.py::safe_public_url`), but any legacy DB row saved
// before that fix landed could still contain a `javascript:` /
// `data:` / `vbscript:` link. Wrapping every user-controlled `href`
// with `safeHref()` guarantees these strings never actually reach the
// DOM as executable navigations — even if they somehow made it
// through the server. Defense in depth.
//
// Usage:
//   <a href={safeHref(link.url)}>...</a>
//
// Returns the URL if it uses an allowed scheme, otherwise `#`.
// Same allowlist as the server: http(s), mailto, tel, or same-origin
// relative path. Everything else is dropped.

const _BARE_DOMAIN = /^[a-z0-9][a-z0-9.\-]*\.[a-z]{2,}(\/.*)?$/i;

export function safeHref(value) {
  if (typeof value !== 'string') return '#';
  const s = value.trim();
  if (!s) return '#';
  const low = s.toLowerCase();
  // Same-origin relative path — no scheme, no exec risk.
  if (low.startsWith('/') && !low.startsWith('//')) return s;
  if (
    low.startsWith('http://') ||
    low.startsWith('https://') ||
    low.startsWith('mailto:') ||
    low.startsWith('tel:')
  ) return s;
  // Bare domain — prepend https so the browser doesn't guess the scheme.
  if (_BARE_DOMAIN.test(low)) return `https://${s}`;
  return '#';
}

export default safeHref;
